import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Project } from '../models/project';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { FolderInfo } from '../models/folder-info';
import { ProjectUser } from '../models/project-user';
import { AccessLevel } from '../models/access-level';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  public constructor(private httpClient: HttpClient) { }

  private readonly apiUrl = '/api/Project/';


  private projectsSubject = new BehaviorSubject<Project[] | null>(null);
  projects$ = this.projectsSubject.asObservable();

  private projectSubject = new BehaviorSubject<Project | null>(null);
  project$ = this.projectSubject.asObservable();

  getProjects(): void {
    this.httpClient.get<Project[]>(this.apiUrl + 'get').pipe(take(1)).subscribe({
      next: (result) => this.projectsSubject.next(result),
      error: (err) => console.error('Ошибка загрузки проектов', err),
    });
  }

  loadProject(id: string): void {
    this.httpClient.post(this.apiUrl + id + '/load', null).subscribe();
  }

  getProjectById(id: string): void {
    this.httpClient.get<Project>(this.apiUrl + id + '/get').pipe(take(1)).subscribe({
      next: (result) => this.projectSubject.next(result),
      error: (err) => console.error('Ошибка загрузки проекта', err),
    })
  }

  addProject(project: Project): void {
    this.httpClient.post<Project>(this.apiUrl + 'create', project).subscribe();
  }

  updateProject(project: Project): void {
    console.log(project);
    this.httpClient.put<Project>(this.apiUrl + 'update', project).subscribe();
  }

  deleteProject(id: string): void {
    this.httpClient.delete(this.apiUrl + id + '/delete').subscribe();
  }

  clearProject(id: string): void {
    this.httpClient.post(this.apiUrl + id + '/clear', null).subscribe({
      error: (err) => console.error('Ошибка очистки проекта', err),
    });
  }

  addLocal(project: Project): void {
    const projects = this.projectsSubject.value ?? [];
    this.projectsSubject.next([...projects, project].sort((a, b) => a.name.localeCompare(b.name)));
  }

  updateLocal(project: Project): void {

    const projects = this.projectsSubject.value;

    if (!!projects) {
      this.projectsSubject.next(
        projects.map(p => p.id === project.id ? project : p).sort((a, b) => a.name.localeCompare(b.name)));
    }

    if (this.projectSubject.value?.id === project.id) {
      console.log(project);
      this.projectSubject.next(project);
    }
  }

  removeLocal(projectId: string): void {
    const projects = this.projectsSubject.value;
    if (!projects) return;

    this.projectsSubject.next(
      projects.filter(p => p.id !== projectId).sort((a, b) => a.name.localeCompare(b.name)));

    if (this.projectSubject.value?.id === projectId) {
      this.projectSubject.next(null);
    }
  }

  listFolders(maxDepth: number = 2): Observable<FolderInfo[]> {
    return this.httpClient.get<FolderInfo[]>(this.apiUrl + 'list-folders', { params: { maxDepth } });
  }

  createProjectFromFolder(name: string, rootPath: string): void {
    this.httpClient.post<Project>(this.apiUrl + 'create-from-folder', { name, rootPath }).subscribe({
      error: (err) => console.error('Ошибка создания проекта из папки', err),
    });
  }

  shareProject(projectId: string, userId: string, accessLevel: AccessLevel): Observable<boolean> {
    return this.httpClient.post<boolean>(this.apiUrl + projectId + '/share', { userId, accessLevel });
  }

  getProjectUsers(projectId: string): Observable<ProjectUser[]> {
    return this.httpClient.get<ProjectUser[]>(this.apiUrl + projectId + '/users');
  }
}
